// src/features/game/hooks/useGameTimer.ts

import {
  useEffect,
} from 'react';

import type {
  Dispatch,
  SetStateAction,
} from 'react';

import type {
  PlayGame,
} from '../types/game.types';

interface UseGameTimerParams {
  setGames: Dispatch<
    SetStateAction<PlayGame[]>
  >;

  onExpired: () => void;
}

export const useGameTimer = ({
  setGames,
  onExpired,
}: UseGameTimerParams) => {
  useEffect(() => {
    let shouldRefresh =
      false;

    const timer =
      window.setInterval(
        () => {
          setGames(
            (previousGames) =>
              previousGames.map(
                (game) => {
                  const isRunning =
                    game.gameStatus ===
                      'RUNNING' ||
                    game.gameStatus ===
                      'STARTED';

                  if (
                    !isRunning ||
                    game.levelRemainingSeconds ===
                      null
                  ) {
                    return game;
                  }

                  const nextSeconds =
                    Math.max(
                      0,
                      game.levelRemainingSeconds -
                        1,
                    );

                  if (
                    nextSeconds ===
                    0
                  ) {
                    shouldRefresh =
                      true;
                  }

                  return {
                    ...game,
                    levelRemainingSeconds:
                      nextSeconds,
                  };
                },
              ),
          );

          if (
            shouldRefresh
          ) {
            shouldRefresh =
              false;

            onExpired();
          }
        },
        1000,
      );

    return () => {
      window.clearInterval(
        timer,
      );
    };
  }, [
    setGames,
    onExpired,
  ]);
};